module.exports = __webpack_public_path__ + "static/media/Home Page_website-29.d48a65ad.png";